import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';
import { TPSServerError } from '../errors/TPSServerError';
import { getRawJwt, logout } from '~/services/authentication';

const requestIntercept = (config: InternalAxiosRequestConfig) => {
  const token = getRawJwt();
  if (token !== null) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
};

const responseIntercept = (response: AxiosResponse) => {
  if (response.headers['WWW-Authenticate']) {
    logout();
  }
  return response;
};

const responseErrorIntercept = (error: any) => {
  if (error.response) {
    if (error.response.headers['WWW-Authenticate']) {
      logout();
    }

    if (error.response.data.data) {
      throw new TPSServerError(error.response.data);
    } else {
      throw new Error('Fel vid validering av token.');
    }
  } else {
    throw new Error('Kan inte nå servern, försök igen senare.');
  }
};

axios.interceptors.request.use(requestIntercept);
axios.interceptors.response.use(responseIntercept, responseErrorIntercept);
